/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseIdDocumentRecordsInnerPlan } from './get-trustdock-verifications200-response-id-document-records-inner-plan';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInner } from './get-trustdock-verifications200-response-id-document-records-inner-reasons-inner';
// May contain unused imports in some cases
// @ts-ignore
import { GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResult } from './get-trustdock-verifications200-response-id-document-records-inner-result';

/**
 * 
 * @export
 * @interface GetTrustdockVerifications200ResponseIdDocumentRecordsInner
 */
export interface GetTrustdockVerifications200ResponseIdDocumentRecordsInner {
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'state': GetTrustdockVerifications200ResponseIdDocumentRecordsInnerStateEnum;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResult}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'result': GetTrustdockVerifications200ResponseIdDocumentRecordsInnerResult | null;
    /**
     * 
     * @type {string}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'verifiedAt': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'verifiedBy': Array<string> | null;
    /**
     * 
     * @type {GetTrustdockVerifications200ResponseIdDocumentRecordsInnerPlan}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'plan': GetTrustdockVerifications200ResponseIdDocumentRecordsInnerPlan | null;
    /**
     * 
     * @type {object}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'document': object | null;
    /**
     * 
     * @type {Array<GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInner>}
     * @memberof GetTrustdockVerifications200ResponseIdDocumentRecordsInner
     */
    'reasons': Array<GetTrustdockVerifications200ResponseIdDocumentRecordsInnerReasonsInner> | null;
}

export const GetTrustdockVerifications200ResponseIdDocumentRecordsInnerStateEnum = {
    accepted: 'accepted',
    plansSelected: 'plans_selected',
    documentSubmitted: 'document_submitted',
    inProgress: 'in_progress',
    verified: 'verified'
} as const;

export type GetTrustdockVerifications200ResponseIdDocumentRecordsInnerStateEnum = typeof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerStateEnum[keyof typeof GetTrustdockVerifications200ResponseIdDocumentRecordsInnerStateEnum];


